module.exports = __webpack_public_path__ + "85b639e1e9f329bdadf8e947a51b19b0.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/ers-logo.png
 ** module id = 1468
 ** module chunks = 0
 **/